<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    @ok="onSave"
    @cancel="onClose"
    v-if="visible"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="部门名称" prop="deptName">
            <InputText v-model="ruleForm.deptName" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="所属机构" prop="orgName">
            <LenovoSelectModule
              :reset="true"
              placeholder="请输入"
              v-model="ruleForm.orgName"
              apiType="getPubOrganName"
              modelKey="name"
              :paramsListObj="{ name: 'name', id: 'id' }"
              @change="handleOrg"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="上级部门" prop="parentName">
            <LenovoSelectModule
              :reset="true"
              placeholder="请输入"
              v-model="ruleForm.parentName"
              apiType="getPubDeptName"
              modelKey="name"
              :paramsListObj="{ name: 'name', id: 'id' }"
              @change="handleDepart"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="联系人" prop="deptContactName">
            <InputText v-model="ruleForm.deptContactName" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="联系方式" prop="deptContactPhone">
            <InputText v-model="ruleForm.deptContactPhone" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="地址" prop="deptAddr">
            <InputText v-model="ruleForm.deptAddr" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="状态" prop="dataStatus">
            <SelectModule
              v-model="ruleForm.dataStatus"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'dept_status' }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import CascaderLazy from "@/components/form/CascaderLazy"; // 级联选择
import API from "@/api/sysManage.js"; // 请求接口
export default {
  components: {
    InputText,
    SelectModule,
    LenovoSelectModule,
    CascaderLazy,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    title() {
      let str = "";
      if (JSON.stringify(this.modalData) != "{}") {
        str = "编辑";
      } else {
        str = "新增";
      }
      return str;
    },
  },
  data() {
    return {
      ruleForm: {
        id: "", // 主键ID
        deptName: "", // 部门名称
        orgName: "", // 组织机构名称
        parentName: "", // 上级组织机构id
        parentId: "", // 上级组织机构name

        deptContactName: "", // 联系人
        deptContactPhone: "", // 联系方式
        deptAddr: "", // 地址
        dataStatus: "", // 数据状态0停用1启用-字典(organ_status)
      },
      rules: {
        deptName: [
          {
            required: true,
            message: "请输入部门名称!",
            trigger: "change",
          },
        ],
        orgName: [
          { required: true, message: "请输入所属机构!", trigger: "change" },
        ],
        parentName: [
          {
            required: true,
            message: "请选择上级组织机构名称!",
            trigger: "change",
          },
        ],
        deptContactName: [
          { required: true, message: "请输入联系人!", trigger: "change" },
        ],
        deptContactPhone: [
          { required: true, message: "请输入联系方式!", trigger: "change" },
        ],
        deptAddr: [
          { required: true, message: "请输入地址!", trigger: "change" },
        ],
        dataStatus: [
          { required: true, message: "请选择状态!", trigger: "change" },
        ],
      },
      visible: false,
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 选择组织机构
    handleOrg(name, obj) {
      this.ruleForm.orgId = obj ? obj.id : "";
      this.ruleForm.orgName = obj ? obj.name : "";
    },
    // 选择部门
    handleDepart(name, obj) {
      this.ruleForm.parentId = obj ? obj.id : "";
      this.ruleForm.parentName = obj ? obj.name : "";
    },
    // 获取角色详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
          },
        },
      };
      API.getPubDeptInfo(params, (callback) => {
        let data = {};
        if (callback.status == "S" && callback.data) {
          data = callback.data;
          for (let key in this.ruleForm) {
            if (data.hasOwnProperty(key)) {
              if (key == "dataStatus") {
                this.ruleForm[key] = data[key].toString() || [];
              } else {
                this.ruleForm[key] = data[key] || "";
              }
            }
          }
          
        }
      });
    },
    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      let params = {
        data: {
          params: {
            ...this.ruleForm,
          },
        },
      };
      API.savePubDeptInfo(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (JSON.stringify(this.modalData) != "{}") {
            str = "编辑";
          } else {
            str = "新增";
          }
          this.$message.destroy();
          this.$message.success(`${str}成功`);
          this.$emit("handleFlag", false, {}, "ok");
        }
      });
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        }
      } else {
        this.ruleForm = {
          id: "", // 主键ID
          deptName: "",
          orgId: "",
          orgName: "", // 组织机构名称
          parentName: "", // 上级组织机构id
          parentId: "", // 上级组织机构name
          deptContactName: "", // 联系人
          deptContactPhone: "", // 联系方式
          deptAddr: "", // 地址
          dataStatus: "", // 数据状态0停用1启用-字典(organ_status)
        };
      }
    },
  },
};
</script>
